import React, { useEffect, useState } from 'react';

import { LottieAnimation } from 'components/animation';
import { HapticsNotificationType, hapticNotification } from 'utils/haptic';

import animation from './animations/confetti-burst.json';
import { SuccessAnimationWrapper } from './loyalty-opt-in-modal.styled';

export const SuccessAnimation = () => {
  const [isComplete, setIsComplete] = useState(false);
  useEffect(() => {
    hapticNotification({ type: HapticsNotificationType.SUCCESS });
  }, []);

  if (isComplete) {
    return null;
  }

  return (
    <SuccessAnimationWrapper>
      <LottieAnimation
        options={{ animationData: animation, loop: false }}
        onComplete={() => setIsComplete(true)}
      />
    </SuccessAnimationWrapper>
  );
};
